var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pendo-input-number',{staticClass:"number-input",class:(_vm.field + "-number-input"),attrs:{"value":_vm.value,"labels":_vm.labels,"min":_vm.min,"max":_vm.max,"input-width":"100%"},on:{"change":_vm.onNumberChange}})}
var staticRenderFns = []

export { render, staticRenderFns }